import { render } from "./AutoWrapping.vue?vue&type=template&id=0e59244c"
import script from "./AutoWrapping.vue?vue&type=script&lang=ts"
export * from "./AutoWrapping.vue?vue&type=script&lang=ts"
script.render = render

export default script